import get from 'lodash/get';
import errorCodes from '../../utils/errorCodes';
import logCategoryActionLabel from '../../loggers/logCategoryActionLabel';
import { actions } from '../constants/logging';

export default (
  error,
  timeoutAction,
  statusAction,
  isInstreamLoggingEnabled,
) => {
  if (!isInstreamLoggingEnabled) {
    return;
  }

  const msg = get(error, 'message', '');
  const code = get(error, 'code', '');
  const codeIndex = msg.indexOf('code');

  if (code === errorCodes.ECONNABORTED) {
    logCategoryActionLabel({ action: timeoutAction });
  } else if (codeIndex >= 0) {
    const statusCode = msg.substring(codeIndex + 5);
    logCategoryActionLabel({ action: `${statusAction}.${statusCode}` });
  } else {
    logCategoryActionLabel(
      { action: actions.instreamRequestTrackingDataError },
      { message: msg },
    );
  }
};
